import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

const MAX = 36;
const SLICE = -6;

@Directive({
  selector: '[appDisableAutofill]',
})
export class DisableAutofillDirective implements AfterViewInit {
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    const randomString = Math.random().toString(MAX).slice(SLICE);
    this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
  }
}
